import React, { useState, useRef, useEffect } from 'react';
import { LuFlame } from 'react-icons/lu';
import './HeatmapToggle.css';

interface HeatmapToggleProps {
  showHeatmap: boolean;
  onToggle: (value: boolean) => void;
}

const HeatmapToggle: React.FC<HeatmapToggleProps> = ({ showHeatmap, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);
  const [localHeatmap, setLocalHeatmap] = useState(showHeatmap);

  useEffect(() => {
    setLocalHeatmap(showHeatmap);
  }, [showHeatmap]);

  // Close panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSave = () => {
    onToggle(localHeatmap);
    setIsOpen(false);
  };

  const hasChanges = localHeatmap !== showHeatmap;

  return (
    <div className="heatmap-toggle-panel" ref={panelRef}>
      <button
        className={`heatmap-toggle-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Map Settings"
      >
        <LuFlame size={18} />
      </button>

      {isOpen && (
        <div className="heatmap-toggle-dropdown">
          <div className="heatmap-toggle-header">
            <span className="heatmap-toggle-title">Map Settings</span>
          </div>
          <div className="heatmap-toggle-body">
            <label className="heatmap-toggle-option">
              <input
                type="checkbox"
                checked={localHeatmap}
                onChange={(e) => setLocalHeatmap(e.target.checked)}
              />
              <span className="heatmap-toggle-option-label">Crime Heatmap</span>
            </label>
          </div>
          <div className="heatmap-toggle-footer">
            <button
              className={`heatmap-toggle-save-btn ${!hasChanges ? 'disabled' : ''}`}
              onClick={handleSave}
              disabled={!hasChanges}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeatmapToggle;
